import { useState, useCallback } from "react";
import { ncdAPI } from "../../../services/ncd.api";

export const useLocationData = () => {
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);

  const fetchDistricts = useCallback(async (stateId) => {
    if (!stateId) {
      setDistricts([]);
      return;
    }

    try {
      const response = await ncdAPI.getStateChildren(stateId);
      setDistricts(response?.data || response || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setDistricts([]);
    }
  }, []);

  const fetchTalukas = useCallback(async (districtId) => {
    if (!districtId) {
      setTalukas([]);
      return;
    }

    try {
      const response = await ncdAPI.getDistrictChildren(districtId);
      setTalukas(response || []);
    } catch (error) {
      console.error("Error fetching talukas:", error);
      setTalukas([]);
    }
  }, []);

  const fetchVillages = useCallback(async (subcenterId) => {
    if (!subcenterId) {
      setVillages([]);
      return;
    }

    try {
      const response = await ncdAPI.getVillages(subcenterId);
      setVillages(response?.data?.villages || response || []);
    } catch (error) {
      console.error("Error fetching villages:", error);
      setVillages([]);
    }
  }, []);

  return {
    districts,
    talukas,
    villages,
    setDistricts,
    setTalukas,
    setVillages,
    fetchDistricts,
    fetchTalukas,
    fetchVillages,
  };
};